<template>
  <v-navigation-drawer
    :value="isDrawerOpen"
    app
    floating
    width="260"
    class="app-navigation-menu"
    :right="$vuetify.rtl"
    @input="(val) => $emit('update:is-drawer-open', val)"
    z-index="1000"
  >
    <!-- Navigation Header -->
    <div class="vertical-nav-header d-flex items-center ps-6 pe-5 pt-5 pb-2">
      <router-link
        to="/parent/live-tracking"
        class="d-flex align-center text-decoration-none"
        @click.native="reloadPage"
      >
        <v-img
          :src="require('@/assets/images/logos/logo_4_small_bustracker.png')"
          max-height="30px"
          max-width="30px"
          alt="logo"
          contain
          eager
          class="app-logo me-3"
        ></v-img>
        <v-slide-x-transition>
          <h2 class="app-title text--primary">
            {{ systemName }}
          </h2>
        </v-slide-x-transition>
      </router-link>
    </div>

    <!-- Navigation Items -->
    <v-list expand shaped class="vertical-nav-menu-items pr-5 nav-list-bottom">
      <!--      <nav-menu-link-->
      <!--        title="Dashboard"-->
      <!--        :to="{ name: 'parent-dashboard' }"-->
      <!--        :icon="icons.mdiHomeOutline"-->
      <!--      ></nav-menu-link>-->
      <nav-menu-section-title
        :title="$t('sidebar.live')"
      ></nav-menu-section-title>
      <nav-menu-link
        :title="$t('sidebar.live_tracking')"
        :to="{ name: 'parent-live-tracking' }"
        icon="mdi-crosshairs-gps"
      ></nav-menu-link>
      <nav-menu-section-title
        :title="$t('sidebar.users')"
      ></nav-menu-section-title>
      <nav-menu-link
        :title="$t('sidebar.students')"
        :to="{ name: 'parent-students' }"
        icon="mdi-badge-account-outline"
      ></nav-menu-link>
      <nav-menu-link
        :title="$t('sidebar.absences')"
        :to="{ name: 'parent-absences' }"
        icon="mdi-calendar-remove-outline"
      ></nav-menu-link>
      <nav-menu-section-title
        :title="$t('sidebar.payments')"
      ></nav-menu-section-title>
      <nav-menu-link
        :title="$t('sidebar.payments')"
        :to="{ name: 'parent-payments' }"
        icon="mdi-credit-card-multiple-outline"
      ></nav-menu-link>
      <nav-menu-section-title
        :title="$t('sidebar.general')"
      ></nav-menu-section-title>
      <nav-menu-link
        :title="$t('sidebar.notifications')"
        :to="{ name: 'parent-notifications' }"
        icon="mdi-bell-outline"
      ></nav-menu-link>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { Keys } from '@/config';
import auth from '@/services/AuthService';
import NavMenuLink from '@/layouts/components/vertical-nav-menu/components/NavMenuLink.vue';
import NavMenuSectionTitle from '@/layouts/components/vertical-nav-menu/components/NavMenuSectionTitle.vue';
import { mdiHomeOutline } from '@mdi/js';

export default {
  components: { NavMenuSectionTitle, NavMenuLink },
  props: {
    isDrawerOpen: {
      type: Boolean,
      default: null,
    },
  },
  setup() {
    return {
      icons: {
        mdiHomeOutline,
      },
      systemName: Keys.VUE_APP_SYSTEM_NAME,
    };
  },
  data() {
    return {
      internalIsDrawerOpen: false,
      mode: null,
    };
  },
  mounted() {
    this.mode = auth.getMode();
  },
  methods: {
    reloadPage() {
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
}

// ? Adjust this `translateX` value to keep logo in center when vertical nav menu is collapsed (Value depends on your logo)
.app-logo {
  transition: all 0.18s ease-in-out;
  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }
}

@include theme(app-navigation-menu) using ($material) {
  background-color: map-deep-get($material, 'background');
}

.app-navigation-menu {
  .v-list-item {
    &.vertical-nav-menu-link {
      ::v-deep .v-list-item__icon {
        .v-icon {
          transition: none !important;
        }
      }
    }
  }
}

// You can remove below style
// Upgrade Banner
.app-navigation-menu {
  .upgrade-banner {
    position: absolute;
    bottom: 13px;
    left: 50%;
    transform: translateX(-50%);
  }
}
.nav-list-bottom {
  padding-bottom: calc(56px + env(safe-area-inset-bottom, 0px)) !important;
}
</style>
